module.exports = __webpack_public_path__ + "static/media/M93ws.191ca78d.pdf";